<template>
  <el-pagination @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 :current-page.sync="page"
                 size="medium"
                 :page-sizes="[10, 20, 50, 100]"
                 :page-size.sync="size"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="total"
                 background
                 class="pagination">
  </el-pagination>
</template>
<script>
export default {
  name: 'PaginationCustom',
  props: {
    pageSize: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    };
  },
  computed: {
    size: {
      get() {
        return this.pageSize;
      },
      set(value) {
        this.$emit('update:page-size', value);
      }
    },
    page: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.$emit('update:current-page', value);
      }
    }
  },
  watch: {
    total(value) {
      if (this.size * (this.currentPage - 1) >= value && this.currentPage > 1) {
        this.page = this.page - 1;
        this.$emit('current-change', this.currentPage - 1);
      }
    }
  },
  methods: {
    handleSizeChange(size) {
      this.size = size;
      this.$emit('size-change', size);
    },
    handleCurrentChange(currentPage) {
      this.page = currentPage;
      this.$emit('current-change', currentPage);
    },
  }
};
</script>
<style lang="scss" scoped>
.pagination {
  padding: 0;
  padding-top: 20px;
  text-align: right;
  border-top: 1px solid #e5e7ed;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PaginationCustom.vue